function getCurrentDate() {
  var currentDate = new Date();
  var year = currentDate.getFullYear();
  var month = ('0' + (currentDate.getMonth() + 1)).slice(-2);
  var day = ('0' + currentDate.getDate()).slice(-2);
  return year + '-' + month + '-' + day;
}

const compareDates = (date1, date2) => {
  return new Date(date1) - new Date(date2);
};